import { useClerk } from "@clerk/clerk-expo";
import { useMagicLinkTokens } from "@features/auth/hooks/useMagicLinkTokens";
import { captureErrorToSentry } from "@helpers/sentry-logger";
import { Stack } from "expo-router";
import { useCallback, useEffect } from "react";

export default function Layout() {
	const { sessionId } = useMagicLinkTokens();
	const { setActive } = useClerk();

	const verifySession = useCallback(async () => {
		try {
			if (sessionId) {
				await setActive({ session: sessionId });
			}
		} catch (err: unknown) {
			const error = new Error("Email link verification error");
			captureErrorToSentry(error, { error: JSON.stringify(err) });
		}
	}, [sessionId, setActive]);

	useEffect(() => {
		verifySession();
	}, [verifySession]);

	return (
		<Stack>
			<Stack.Screen name="login" />
			<Stack.Screen name="verify" />
			<Stack.Screen name="auth/verify" />
			<Stack.Screen name="auth/unauthorized" />
		</Stack>
	);
}
